export const IMAGE_RATIO_HEIGHT = 22
export const IMAGE_RATIO_WIDTH = 15

export type ImageType = {
  id: string
  src: string
  backName: BackgroundVideoName
  style: {
    height: string | number
    top: string | number
    bottom: string | number
    backgroundImage: string
    backgroundPosition: string
  }
}

export type BackgroundVideoName = 'blue' | 'gray'

export type BackgroundVideoType = {
  name: BackgroundVideoName
  videoSrc: string
  imgSrc: string
}

export type BarType = {
  id: string
  src: string
  style: {
    top: string | number
    bottom: string | number
    display: string
    backgroundImage: string
  }
}
